import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type SearchFiltersMetadataAppState = { metadataViewId?: string | undefined };

const initialState: SearchFiltersMetadataAppState = {
  metadataViewId: undefined,
};

export const searchFiltersMetadataSlice = createSlice({
  name: 'search_filters_metadata',
  initialState,
  reducers: {
    setSearchFiltersMetadataViewId: (
      state,
      action: PayloadAction<string | undefined>,
    ) => {
      state.metadataViewId = action.payload;
    },
  },
});

export const { setSearchFiltersMetadataViewId } =
  searchFiltersMetadataSlice.actions;

export const searchFiltersMetadataReducer = searchFiltersMetadataSlice.reducer;
